<template>
  <div>
    <b-table id="table_classement" hover small responsive :items="filter_finisher_classement" :fields="fields" @row-clicked="openFicheCoureur">
      <template #cell(nom)="data">
        <p>
          <img class="flag" :src="'https://sportips.fr/live/img/Flags/' + data.item.nation + '.jpg'" /> <b>{{ data.item.nom }} {{ data.item.prenom }}</b>
        </p>
      </template>
      <template #cell(points)="data">
        <b>{{ data.item.points }}</b>
      </template>
      <template #cell(fiche)="data">
        <b-button class="btn_fiche" @click="openFicheCoureur(data.item)">
          <b-icon icon="plus-square-fill" aria-hidden="true" />
        </b-button>
      </template>
    </b-table>
    <h2 style="text-align: left">Participants non classés</h2>
    <b-table id="table_classement" hover small responsive :items="filter_non_finisher_classement" :fields="fields" @row-clicked="openFicheCoureur">
      <template #cell(nom)="data">
        <p>
          <img class="flag" :src="'https://sportips.fr/live/img/Flags/' + data.item.nation + '.jpg'" /> <b>{{ data.item.nom }} {{ data.item.prenom }}</b>
        </p>
      </template>
      <template #cell(points)="data">
        <b>{{ data.item.points }}</b>
      </template>
      <template #cell(fiche)="data">
        <b-button class="btn_fiche" @click="openFicheCoureur(data.item)">
          <b-icon icon="plus-square-fill" aria-hidden="true" />
        </b-button>
      </template>
    </b-table>
    <p v-if="classement.length === 0"><b>Il n'y a pas encore de participant à ce challenge</b></p>
  </div>
</template>

<script>
export default {
  props: ["classement"],
  //watch deep search
  watch: {
    classement: function () {
      this.classement_finisher = [];
      this.classement_non_finisher = [];
      for (var i = 0; i < this.classement.length; i++) {
        if (this.classement[i].nb_participations >= 8) {
          this.classement[i].classement = this.classement_finisher.length + 1;
          this.classement_finisher.push(this.classement[i]);
        } else {
          this.classement[i].classement = "";
          this.classement_non_finisher.push(this.classement[i]);
        }
      }
    },
  },
  computed: {
    filter_finisher_classement() {
      var filteredClassement = JSON.parse(JSON.stringify(this.classement_finisher));
      if (this.$store.state.search_terms) {
        if (this.$store.state.classement_type === "Homme" || this.$store.state.classement_type === "Femme") {
          filteredClassement = filteredClassement.filter((item) => item.nom.includes(this.$store.state.search_terms.toUpperCase()) || item.prenom.toUpperCase().includes(this.$store.state.search_terms.toUpperCase()));
        } else {
          filteredClassement = filteredClassement.filter((item) => item.name.includes(this.$store.state.search_terms.toUpperCase()));
        }
      }
      return filteredClassement;
    },
    filter_non_finisher_classement() {
      var filteredClassement = JSON.parse(JSON.stringify(this.classement_non_finisher));
      if (this.$store.state.search_terms) {
        if (this.$store.state.classement_type === "Homme" || this.$store.state.classement_type === "Femme") {
          filteredClassement = filteredClassement.filter((item) => item.nom.includes(this.$store.state.search_terms.toUpperCase()) || item.prenom.toUpperCase().includes(this.$store.state.search_terms.toUpperCase()));
        } else {
          filteredClassement = filteredClassement.filter((item) => item.name.includes(this.$store.state.search_terms.toUpperCase()));
        }
      }
      return filteredClassement;
    },
  },
  data() {
    return {
      classement_finisher: [],
      classement_non_finisher: [],
      fields: [
        { key: "classement", label: "Clt", sortable: true },
        { key: "nom", label: "Nom", sortable: true },
        { key: "categorie", label: "Catégorie" },
        { key: "points", label: "Points", sortable: true },
        {
          key: "nb_participations",
          label: "Nb participations",
          sortable: true,
        },
        { key: "club", label: "Club" },
        { key: "entreprise", label: "Entreprise" },
        { key: "fiche", label: "Fiche" },
      ],
    };
  },
  methods: {
    openFicheCoureur(data) {
      var fiche_path = "coureur/" + data.id;
      this.$router.push({ path: fiche_path });
    },
  },
  created() {
    for (var i = 0; i < this.classement.length; i++) {
      if (this.classement[i].nb_participations >= 8) {
        this.classement[i].classement = this.classement_finisher.length + 1;
        this.classement_finisher.push(this.classement[i]);
      } else {
        this.classement[i].classement = "";
        this.classement_non_finisher.push(this.classement[i]);
      }
    }
  },
};
</script>

<style lang="scss">
th {
  background-color: #1c2681 !important;
}
</style>
